import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logoGala from '../assets/common/LogoGala.png';
import { routeForRole } from '../utils/roleRoute';
import './SplashScreen.css';

// Durée minimale d'affichage du splash : évite un flash du logo/spinner quand la
// restauration de session répond très vite (jetons valides en cache réseau).
const MIN_SPLASH_MS = 1400;

const SplashScreen = () => {
  const navigate = useNavigate();
  const { restoreSession } = useAuth();
  // Garde contre le double-run de l'effet en StrictMode (dev) : on ne lance la
  // restauration qu'une seule fois.
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    let cancelled = false;
    const startedAt = Date.now();

    (async () => {
      let profile = null;
      try {
        profile = await restoreSession();
      } catch (_) {
        profile = null;
      }
      const remaining = Math.max(0, MIN_SPLASH_MS - (Date.now() - startedAt));
      setTimeout(() => {
        if (cancelled) return;
        navigate(profile ? routeForRole(profile.role) : '/connexion', { replace: true });
      }, remaining);
    })();

    return () => { cancelled = true; };
  }, [navigate, restoreSession]);

  return (
    <div className="page page--centered">
      <div className="splash-logo-container">
        <img src={logoGala} alt="CycleGala" className="splash-logo" role="status" aria-label="Chargement" />
      </div>
    </div>
  );
};

export default SplashScreen;
